import React, { useEffect } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import ShopifyOrder from './ShopifyOrder';
import ShopifyProduct from './ShopifyProduct';
import ShopifyDashboard from './ShopifyDashboard';
import ShopifyMissingSkus from './ShopifyMissingSkus';
import ShopifyJobAndStatus from './ShopifyJobAndStatus.tsx';
import ShopifyIssues from './ShopifyIssues';
import ShopifyAdminAccounts from './ShopifyAdminAccounts';

const ShopifyOverview: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const path = location.pathname;
  const activeKey = path.endsWith('/products') ? 'products' : (
    path.endsWith('/orders') ? 'orders' : (
      path.endsWith('/missing') ? 'missing' : (
        path.endsWith('/job') ? 'job' : (
          path.endsWith('/issues') ? 'issues' : (
            path.endsWith('/admin-accounts') ? 'admin-accounts' : 'dashboard'
          )
        )
      )
    )
  );

  useEffect(() => {
    // 保持網址與分頁同步
    // 保持簡單：若直接訪 /integrations/shopify 則保持 dashboard
  }, [activeKey]);

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => {
        if (key === 'products') navigate('/integrations/shopify/products');
        else if (key === 'orders') navigate('/integrations/shopify/orders');
        else if (key === 'missing') navigate('/integrations/shopify/missing');
        else if (key === 'job') navigate('/integrations/shopify/job');
        else if (key === 'issues') navigate('/integrations/shopify/issues');
        else if (key === 'admin-accounts') navigate('/integrations/shopify/admin-accounts');
        else navigate('/integrations/shopify');
      }}
      items={[
        { key: 'dashboard', label: 'Shopify Dashboard', children: <ShopifyDashboard /> },
        { key: 'issues', label: 'Shopify Issues', children: <ShopifyIssues /> },
        { key: 'admin-accounts', label: 'Shopify Admin Accounts', children: <ShopifyAdminAccounts /> },
        { key: 'job', label: 'Shopify Job & Status', children: <ShopifyJobAndStatus /> },
        { key: 'orders', label: 'Shopify Order', children: <ShopifyOrder /> },
        { key: 'products', label: 'Shopify Product', children: <ShopifyProduct /> },
        { key: 'missing', label: 'Shopify Missing SKUs', children: <ShopifyMissingSkus /> },
      ]}
    />
  );
};

export default ShopifyOverview;


